import {Message} from 'com/gongxigames/math/core/game/message/Message';
import {Field} from 'com/gongxigames/math/core/game/message/Field';
import {PPRequest} from '@gongxigames/framework/integrations/pariplay/request/PPRequest';
import {PPPlaceBetResponse} from '@gongxigames/framework/integrations/pariplay/response/PPPlaceBetResponse';
import {PPSettings} from '@gongxigames/framework/integrations/pariplay/PPSettings';
import {PPEndGameRequest} from '@gongxigames/framework/integrations/pariplay/request/PPEndGameRequest';
import {PPNotificationRequest} from '@gongxigames/framework/integrations/pariplay/request/PPNotificationRequest';
import {PPGameClientWrapper} from '@gongxigames/framework/integrations/pariplay/PPGameClientWrapper';
import {PPConfiguration} from '@gongxigames/framework/integrations/pariplay/PPConfiguration';
import {IBrowser} from '@gongxigames/framework/core';
import {ServerMessage, Xhr} from '@gongxigames/framework/slot';

export class PPPlaceBetRequest extends PPRequest<PPPlaceBetResponse> {
    protected settings: PPSettings;
    protected message: Message;
    protected endGameRequest!: PPEndGameRequest;
    protected notificationRequest!: PPNotificationRequest;
    protected count: number;
    protected bet: number;
    protected client: PPGameClientWrapper;

    constructor(config: PPConfiguration, browser: IBrowser, settings: PPSettings, bet: number, message: Message,
        client: PPGameClientWrapper) {
        super(config, browser);
        this.bet = bet;
        this.settings = settings;
        this.message = message;
        this.count = 0;
        this.client = client;
    }

    protected getURL(): string {
        return this.config.RgsUrl + '/client/' + this.config.PlaceBetUrl;
    }

    protected startNotification(): void {
        this.notificationRequest = new PPNotificationRequest(this.config, this.browser);
        this.notificationRequest.load((data: any) => {
            this.processResponse(data);
        }, null!, null!);
    }

    protected sendEndGame(): void {
        this.endGameRequest = new PPEndGameRequest(this.config, this.browser);
        this.endGameRequest.load(() => {
            this.callback();
        }, this.on_error, this.onSlowRequest);
    }

    protected processResponse(data: any): void {
        if (data) {
            this.response = new PPPlaceBetResponse(data);

            if (this.response.getErrorType() > 0) {
                this.response.getErrorType() === 2 && this.startNotification();
                this.on_error(data);
            } else {
                this.config.ticketID = this.response.getTicketID();

                this.sendEndGame();
            }
        } else {
            this.on_error && this.on_error();
        }
    }

    public getRPBody(): any {
        return this.response.getRPBody();
    }

    public getSource(): any {
        return this.response.source;
    }

    protected getParams(): string {
        const data: any = {};
        const messageBet = this.message.getField<number>(Field.BET);
        const bet = (messageBet !== undefined && messageBet !== null) ? messageBet : this.bet;
        const input: any = {};

        input.Stake = PPConfiguration.convertIntToDouble(bet);
        input.EngineInput = encodeURIComponent(Xhr.objectToKeyValue(this.message.getFields()));
        data.input = JSON.stringify(input);
        data.PlayerTokenId = this.config.playerTokenID;

        return Xhr.objectToKeyValue(data);
    }

    public process(wrapper: PPGameClientWrapper, response: ServerMessage): ServerMessage[] {
        const msgs: ServerMessage[] = [];
        const messages: ServerMessage[] = this.response.getMessages();

        msgs.push(response);

        for (const msg of messages) {
            msgs.push(msg);
        }

        return msgs;
    }

    public getBalance(): number {
        return this.response.getBalance();
    }
}
